import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UploadplanilhaComponent } from './uploadplanilha/uploadplanilha.component';
import { MatTableModule } from '@angular/material/table';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import {
  CnpjPipe,
  CnpjValidoPipe,
  CsvPostoCodigoPipe,
  CsvPostoPipe,
} from './csv-posto.pipe';
import {CurrencyMaskModule} from "ng2-currency-mask";

export const routes: Routes = [
  { path: '', component: UploadplanilhaComponent },

];

@NgModule({
  declarations: [
    UploadplanilhaComponent,
    CnpjPipe,
    CnpjValidoPipe,
    CsvPostoPipe,
    CsvPostoCodigoPipe
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatTableModule,
    FormsModule,
    HttpClientModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatFormFieldModule,
    CurrencyMaskModule,

  ],
  exports: [CnpjPipe],
  providers: [CnpjPipe, CnpjValidoPipe, CsvPostoPipe, CsvPostoCodigoPipe]
})
export class UploadcsvModule { }
